(function () {
  'use strict';

  /* ---------- Menu mobile (accessibile) ---------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Galleria prodotto (unico handler) ---------- */
  var gallery = document.querySelector('[data-gallery]');
  var mainImg = document.getElementById('MainImage');
  if (gallery && mainImg) {
    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var src = btn.getAttribute('data-src');
      if (!src) return;
      // srcset/sizes vanno rimossi, altrimenti il browser ignora il nuovo src
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
      var alt = btn.getAttribute('data-alt');
      if (alt) mainImg.alt = alt;
      gallery.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
    });
  }

  /* ---------- Quantità +/- ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val += parseInt(btn.getAttribute('data-qty'), 10);
      input.value = Math.max(1, val);
    });
  });

  /* ---------- Form prodotto: opzioni, offerte, disponibilità ---------- */
  var form = document.getElementById('product-form');
  if (form) {
    var buyId = document.getElementById('BuyId');
    var addBtn = document.getElementById('AddBtn');
    var stickyBtn = document.querySelector('[data-sticky-add]');
    var dataEl = document.getElementById('ProductVariantData');
    var pageVariants = null;
    if (dataEl) {
      try { pageVariants = JSON.parse(dataEl.textContent); } catch (e) { pageVariants = null; }
    }

    function selectedOptions() {
      var vals = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        vals.push(checked ? checked.value : null);
      });
      return vals;
    }

    function matchVariant(variants, opts) {
      if (!variants || !variants.length) return null;
      // bundle senza opzioni: c'è una sola variante, è quella giusta
      if (variants.length === 1) return variants[0];
      var exact = variants.find(function (v) {
        if (!v.o || v.o.length !== opts.length) return false;
        return opts.every(function (val, i) { return val === null || v.o[i] === val; });
      });
      if (exact) return exact;
      // fallback per prodotti bundle con opzioni diverse: match per titolo
      var loose = null;
      opts.forEach(function (val) {
        if (loose || val === null) return;
        loose = variants.find(function (v) {
          return v.a && v.t && v.t.toLowerCase().indexOf(val.toLowerCase()) !== -1;
        });
      });
      // niente match: meglio disabilitare l'acquisto che aggiungere la variante sbagliata
      return loose || null;
    }

    function setText(sel, txt) {
      var el = document.querySelector(sel);
      if (el && txt != null) el.textContent = txt;
    }

    function setButtonState(available, priceText) {
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !available;
        var label = available ? b.getAttribute('data-text-add') : b.getAttribute('data-text-soldout');
        var priceSpan = b.querySelector('[data-btn-price]');
        if (priceSpan) {
          var labelSpan = b.querySelector('[data-btn-label]');
          if (labelSpan && label) labelSpan.textContent = label;
          if (available && priceText) priceSpan.textContent = priceText;
          priceSpan.style.display = available ? '' : 'none';
        } else if (label) {
          b.textContent = label;
        }
      });
    }

    function resolve() {
      var opts = selectedOptions();
      var offer = form.querySelector('.offer input[name="offer"]:checked');
      var variants = pageVariants;
      if (offer) {
        try { variants = JSON.parse(offer.getAttribute('data-variants')); } catch (e) { /* usa quelle di pagina */ }
        form.querySelectorAll('.offer').forEach(function (o) { o.classList.remove('on'); });
        var card = offer.closest('.offer');
        if (card) card.classList.add('on');
      }
      // ogni card offerta mostra il prezzo della variante che verrebbe aggiunta
      form.querySelectorAll('.offer input[name="offer"]').forEach(function (r) {
        var ov = null;
        try { ov = JSON.parse(r.getAttribute('data-variants')); } catch (e) { return; }
        var op = matchVariant(ov, opts);
        var priceEl = r.closest('.offer').querySelector('[data-offer-price]');
        if (op && priceEl) priceEl.textContent = op.p;
      });
      var pick = matchVariant(variants, opts);
      if (!pick) {
        setButtonState(false, null);
        return;
      }
      if (buyId) buyId.value = pick.id;
      setText('[data-main-price]', pick.p);
      setText('[data-sticky-price]', pick.p);
      var old = document.querySelector('[data-main-old]');
      if (old) old.textContent = (offer && offer.getAttribute('data-compare')) || pick.c || '';
      setButtonState(!!pick.a, pick.p);
    }

    form.querySelectorAll('.offer input[name="offer"]').forEach(function (r) {
      r.addEventListener('change', resolve);
    });
    form.querySelectorAll('[data-option-index] input').forEach(function (c) {
      c.addEventListener('change', resolve);
    });
    if (form.querySelector('.offer input[name="offer"]') || form.querySelector('[data-option-index]')) {
      resolve();
    }
  }

  /* ---------- Carrello: aggiorna al cambio quantità ---------- */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.querySelectorAll('[data-cart-qty]').forEach(function (inp) {
      inp.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* ---------- Popup newsletter ---------- */
  var pop = document.getElementById('BlmPop');
  if (pop) {
    var KEY = 'blm_pop_v1';
    var delay = parseInt(pop.getAttribute('data-delay'), 10) || 8;
    var lastFocus = null;
    function seen() {
      try {
        var t = localStorage.getItem(KEY);
        return t && (Date.now() - parseInt(t, 10)) < 30 * 24 * 3600 * 1000;
      } catch (e) { return false; }
    }
    function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    function openPop() {
      lastFocus = document.activeElement;
      pop.classList.add('open');
      pop.setAttribute('aria-hidden', 'false');
      var first = pop.querySelector('input[type="email"], a.btn, button:not(.blm-pop-x)');
      if (first) first.focus();
    }
    function closePop() {
      pop.classList.remove('open');
      pop.setAttribute('aria-hidden', 'true');
      mark();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    pop.addEventListener('click', function (e) { if (e.target === pop) closePop(); });
    document.addEventListener('keydown', function (e) {
      if (!pop.classList.contains('open')) return;
      if (e.key === 'Escape') { closePop(); return; }
      // focus trap: Tab resta dentro il dialog
      if (e.key === 'Tab') {
        var focusables = pop.querySelectorAll('a[href], button, input, [tabindex="0"]');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        } else if (!pop.contains(document.activeElement)) {
          e.preventDefault(); first.focus();
        }
      }
    });
    var x = pop.querySelector('[data-pop-close]');
    if (x) x.addEventListener('click', closePop);
    var code = pop.querySelector('[data-pop-code]');
    if (code) {
      var copyCode = function () {
        if (navigator.clipboard) navigator.clipboard.writeText(code.textContent.trim());
      };
      code.addEventListener('click', copyCode);
      code.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copyCode(); }
      });
    }
    if (window.__blmPopSuccess) {
      openPop(); mark();
    } else if (!seen()) {
      setTimeout(openPop, delay * 1000);
    }
  }
})();
